import React from 'react'

import Placeholder from 'components/Placeholder'

const GeneratorLoader = () => <Placeholder width="350px" height="30px" />

export default GeneratorLoader
